import '../../components/globals/JobAdDetails.css';

import { Link, useNavigate, useParams } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import { applyJob, getAllSavedJobs, getAppliedJobs, getJobDetails, getLatestJobs, saveJob, unsaveJob } from '../../services/jobService';
import { getUserInfoAndToken, isEmpty, mapAndGetLocationsWithMallIds } from '../../common/helper';

import ApplicationMethodModal from '../../components/modal/ApplicationMethodModal';
import Button from "../../components/button/Button";
import Footer from '../../components/footer/Footer';
import Header from '../../components/header/Header';
import JobApplySuccess from './JobApplySuccess';
import JobLocationSelectionModal from './JobLocationSelectionModal';
import JobLocationSelectionModalMobile from './JobLocationSelectionModalMobile';
import LatestJobs from '../homepage/LatestJobs';
import Loader from '../../components/loader/Loader';
import LocationModal from './LocationModal';
import LocationModalMobile from './LocationModalMobile';
import ProgressiveApplication from '../job-application/ProgressiveApplication';
import Toast from '../../components/toast/Toast';
import ShareJobButtons from '../../containers/job-ad-details/JobShareButtons';
import analytics from '../../firebase';
import { getCodeTableChecksum } from '../../services/HomeService';
import { getProfileDetails } from '../../services/ProfileService';
import { logEvent } from 'firebase/analytics';
import { routes } from '../../common/routes';
import sanitizeHtml from 'sanitize-html';

const toastInitialState = {
    type: '',
    header: '',
    message: ''
}

const JobAdDetails = () => {
    const { userId, username, token } = getUserInfoAndToken();
    const navigate = useNavigate();
    const { jobId } = useParams();
    const [data, setData] = useState({});
    const [latestJobs, setLatestJobs] = useState([]);
    const [isBookmark, setIsBookmark] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [showToast, setShowToast] = useState(false);
    const [toastProps, setToastProps] = useState(toastInitialState)
    const [showLocationModal, setShowLocationModal] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);
    const [showApplicationMethodModal, setShowApplicationMethodModal] = useState(false);
    const [showLocationSelectionModal, setShowLocationSelectionModal] = useState(false);
    const [jobLocations, setJobLocations] = useState([]);
    const [applicationMethod, setApplicationMethod] = useState('');
    const [selectedMallIds, setSelectedMallsIds] = useState([]);
    const [locationLimit, setLocationLimit] = useState(3);
    const [isApplicationOpen, setIsApplicationOpen] = useState(false);
    const [isMobileVerified, setIsMobileVerified] = useState(true);
    const [mobileNumber, setMobileNumber] = useState('');
    const [isLanguageFilled, setIsLanguageFilled] = useState(false);
    const [isEmploymentstatusFilled, setIsEmploymentstatusFilled] = useState(false);
    const [isEducationFilled, setIsEducationFilled] = useState(false);
    const [areAppliedJobsLoading, setAreAppliedJobsLoading] = useState(false);
    const [appliedJobIds, setAppliedJobIds] = useState([]);

    const isMobile = window.innerWidth <= 568;
    const isTablet = window.innerWidth <= 783;

    const handleMoreJobs = () => {
        navigate(routes.jobs.search);
    }

    const handleSeeAll = () => {
        setShowLocationModal(!showLocationModal)
    }

    const handleLocationModalClose = () => {
        setShowLocationModal(false)
    }

    const handleEmployer = () => {
        logEvent(analytics, 'company_profile_viewed', { 'click_source': 'job details' });
        logEvent(analytics, 'company_view_initiated', { 'job_name': data.jobttl, 'job_id': data.jobid, 'company_name': data.coydispm, 'company_id': data.coyid });
        navigate(`/employer/${data.coyid}`);
    }

    const handleApply = () => {
        const isLogin = JSON.parse(localStorage.getItem('isLogin'))
        if (isLogin) {
            setIsApplicationOpen(false);
            logEvent(analytics, 'job_apply_initiated', { 'job_name': data.jobttl, 'job_id': data.jobid, 'company_name': data.coydispm, 'company_id': data.coyid });
            if (jobLocations.length > 0) {
                setShowLocationSelectionModal(true)
            }
            else {
                setShowApplicationMethodModal(true)
            }
        }
        else {
            navigate('/login')
        }
    }

    const handleApplyButtonClick = () => {
        const isLogin = JSON.parse(localStorage.getItem('isLogin'))
        if (isLogin) {
            const showProgressApplication = showProgressiveApplication();
            if (showProgressApplication) {
                setIsApplicationOpen(true);
            }
            else {
                handleApply()
            }
        }
        else {
            navigate('/login')
        }
    }

    const handleSelectionModalClose = () => {
        setShowLocationSelectionModal(false)
    }

    const handleSelectionModalNextButton = () => {
        setShowLocationSelectionModal(false)
        setShowApplicationMethodModal(true)
    }

    const handleCheckboxClick = (e, item) => {
        e.stopPropagation();
        const checkbox =
            e.target.type === "checkbox"
                ? e.target
                : e.target.querySelector('input[type="checkbox"]');
        const isChecked = checkbox.checked;
        let updatedItems = isChecked ? [...selectedMallIds, item] : (selectedMallIds?.includes(item) ? selectedMallIds.filter(value => item !== value) : [...selectedMallIds])
        if (updatedItems.length <= locationLimit) {
            setSelectedMallsIds(updatedItems)
        }

    };

    const getWhatsAppRedirectionUrl = () => {
        const phoneNumber = data?.whatsapp;
        const userInfo = JSON.parse(localStorage.getItem('user'));
        const userName = userInfo?.userName;
        const message = `Hi, I ${userName} would like to apply for the position of ${data.jobttl} from ${data.coydispm}. Please contact me.`
        const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

        return whatsappUrl;
    }

    const handleToastClose = () => {
        setShowToast(false)
        setToastProps(toastInitialState)
    }

    const fetchAllSavedJobs = async () => {
        try {
            const allJobs = await getAllSavedJobs();
            return allJobs
        }
        catch (error) {
            console.log(`Failed to fetch all saved jobs ${error}`)
        }
    }

    const saveJobs = async (cardId) => {
        try {
            const savedRes = await saveJob(cardId);
            if (savedRes.code === '00') {
                setIsBookmark(true);
                setShowToast(true)
                setToastProps({
                    type: 'success',
                    header: 'Job saved successfully',
                    message: <>The job has been added to your <Link to='/saved-jobs'>Saved Jobs</Link> listing.</>
                })
            }
        }
        catch (error) {
            setIsLoading(false);
            setShowToast(true)
            setToastProps({
                type: 'error',
                header: 'Something went wrong',
                message: 'Please try saving the job again'
            })
            console.log(`Failed to save a job ${error}`)
        }
    }

    const unsaveJobs = async (cardId, favId) => {
        try {
            const unsavedRes = await unsaveJob(cardId, favId);
            if (unsavedRes.code === '00') {
                setIsBookmark(false);
                setShowToast(true)
                setToastProps({
                    type: 'success',
                    header: 'Job unsaved successfully',
                    message: <>The job has been removed from your <Link to='/saved-jobs'>Saved Jobs</Link> listing.</>
                })
            }
        }
        catch (error) {
            setIsLoading(false);
            setShowToast(true)
            setToastProps({
                type: 'error',
                header: 'Something went wrong',
                message: 'Please try unsaving the job again'
            })
            console.log(`Failed to unsave a job ${error}`)
        }
    }

    const handleBookmarkClick = async () => {
        setIsLoading(true);
        const savedJobs = await fetchAllSavedJobs();
        const savedJob = savedJobs.find(item => item.jobid === jobId);
        if (savedJob) {
            logEvent(analytics, 'job_unsaved', { 'click_source': 'job details', 'job_name': data.jobttl, 'job_id': data.jobid, 'company_name': data.coydispm, 'company_id': data.coyid });
            await unsaveJobs(jobId, savedJob.favid);
        }
        else {
            await saveJobs(jobId);
        }
        setIsLoading(false);
    }

    const handleJobApply = async () => {
        try {
            setIsLoading(true)
            const outletNames = selectedMallIds.map((item) => item.name);
            const outletNamesCommaSeparated = outletNames.join(", ");
            const mallIds = selectedMallIds.map((item) => item.mallid)
            logEvent(analytics, 'job_apply_method_selected', { 'apply_method': applicationMethod });
            const response = await applyJob(jobId, applicationMethod, mallIds)
            if (response.code === "00") {
                localStorage.setItem("jobSuccess", "true")
                setIsSuccess(true)
            }
            if (applicationMethod === 'WhatsApp') {
                const whatsappUrl = getWhatsAppRedirectionUrl()
                setTimeout(() => {
                    window.open(whatsappUrl, '_blank');
                }, 1000)
            }
            logEvent(analytics, 'job_apply_success', { 'job_name': data.jobttl, 'job_id': data.jobid, 'company_name': data.coydispm, 'company_id': data.coyid, 'outlets': outletNamesCommaSeparated, 'apply_method': applicationMethod });
            setIsLoading(false)
        }
        catch (error) {
            setShowToast(true)
            setToastProps({
                type: 'error',
                header: 'Something went wrong',
                message: 'Please try applying for the job again'
            })
            setIsSuccess(false)
            setIsLoading(false)
            const outletNames = selectedMallIds.map((item) => item.name);
            const outletNamesCommaSeparated = outletNames.join(", ");
            logEvent(analytics, 'job_apply_success', { 'job_name': data.jobttl, 'job_id': data.jobid, 'company_name': data.coydispm, 'company_id': data.coyid, 'outlets': outletNamesCommaSeparated, 'apply_method': applicationMethod });
            console.log(`Failed to apply for job: ${error}`)
        }
    }

    const getUserInfoAndTokens = () => {
        const userInfo = JSON.parse(localStorage.getItem('user'));
        const userId = userInfo?.userId;
        const username = userInfo?.userEmail;
        const token = localStorage.getItem('token');
        return { userId, username, token };
    }

    const fetchAppliedJobs = async () => {
        try {
            setAreAppliedJobsLoading(true);

            const { userId, username, token } = getUserInfoAndTokens();
            const queryParams = { 'per-page': 20, page: 1 };
            let hasNext = true;
            const allJobsIds = [];

            let maxCounter = 1000; // For safety, break the loop after 1000 iterations.
            while (hasNext) {
                if (maxCounter <= 0) {
                    break
                }
                maxCounter--;

                const response = await getAppliedJobs(userId, username, token, queryParams);
                if (response?.code === '00') {
                    const data = response?.data;
                    if (data?.length > 0) {
                        const jobIds = data.map((job) => job?.jobid);
                        allJobsIds.push(...jobIds);
                    } else {
                        break;
                    }
                } else {
                    break;
                }

                if (response.totalResult <= 0) {
                    hasNext = false;
                }

                queryParams.page++;
            }

            setAppliedJobIds(allJobsIds);
            setAreAppliedJobsLoading(false);
        } catch (error) {
            setAreAppliedJobsLoading(false);
            // TODO: handle error
            console.log(`error occurred while fetching the applied jobs: ${error}`);
        }
    }

    const showProgressiveApplication = () => {
        return !isMobileVerified || !isLanguageFilled || !isEmploymentstatusFilled || !isEducationFilled
    }

    const getProfileData = async () => {
        try {
            const response = await getProfileDetails(userId, username, token)
            if (response.code === '00') {
                const isMobVerified = response.data[0].phverifd === "1" ? true : false
                setIsMobileVerified(isMobVerified)
                setMobileNumber(response.data[0].mobm)
                if (response.data[0] && response.data[0].languages && response.data[0].languages?.length > 0) {
                    setIsLanguageFilled(true)
                }
                if (response.data[0] && response.data[0].empsts && !isEmpty(response.data[0].empsts)) {
                    setIsEmploymentstatusFilled(true)
                }
                if (response.data[0] && response.data[0].edulvlc && !isEmpty(response.data[0].edulvlc)) {
                    setIsEducationFilled(true)
                }
            }
        }
        catch (error) {
            console.log(`Error occurred while fetching the profile data: ${error}`);
        }
    }

    useEffect(() => {
        if (!isLoading) {
            setIsLoading(true)
        }
        const fetchJobDetails = async () => {
            try {
                const jobDetails = await getJobDetails(jobId);
                if (jobDetails && jobDetails.data.length > 0) {
                    setData(jobDetails.data[0]);
                    const jobData = jobDetails.data[0];
                    if (jobData.mallids.length > 0 || jobData.outletids.length > 0) {
                        const jobLocationIdSet = new Set([...jobData.mallids, ...jobData.outletids])
                        const jobLocationsIdList = [...jobLocationIdSet]
                        const checksum = await getCodeTableChecksum();
                        const jobLocations = mapAndGetLocationsWithMallIds(checksum.data.en.malls, jobLocationsIdList)
                        const outletLimit = jobData.outletset.length > 0 ? jobData.outletset.length : 3;

                        setLocationLimit(outletLimit)
                        setJobLocations(jobLocations)
                    }
                }
                const savedJobs = await fetchAllSavedJobs();
                const savedJob = savedJobs.find(item => item.jobid === jobId);
                if (savedJob) {
                    setIsBookmark(true);
                }
                setIsLoading(false)
            } catch (error) {
                setIsLoading(false)
                console.log(`Job details fetch error: ${error}`);
                // Todo: Handle error
            }
        }

        fetchJobDetails();
        fetchAppliedJobs();
    }, [jobId]);

    useEffect(() => {
        const fetchLatestJobs = async () => {
            const jobs = await getLatestJobs(13);
            let updatedJobs;

            const index = jobs.findIndex(job => job['jobid'] === jobId);

            if (index !== -1) {
                updatedJobs = jobs.filter((job, i) => i !== index);
            } else {
                updatedJobs = jobs.slice(0, 12);
            }
            setLatestJobs(updatedJobs);
        };

        fetchLatestJobs();
    }, []);

    useEffect(() => {
        getProfileData()
    }, [isApplicationOpen])

    useEffect(() => {
        const handleResize = () => {
            const bodyElement = document.body;

            if (showLocationModal && !isMobile) {
                bodyElement.classList.add('no-scroll');
            }
            else if (showApplicationMethodModal) {
                bodyElement.classList.add('no-scroll');
            }
            else if (showLocationSelectionModal) {
                bodyElement.classList.add('no-scroll');
            }
            else if (isApplicationOpen) {
                bodyElement.classList.add('no-scroll');
            }
            else {
                bodyElement.classList.remove('no-scroll');
            }
        };

        window.addEventListener('resize', handleResize);

        handleResize();

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [showApplicationMethodModal, showLocationSelectionModal, showLocationModal, isMobile, isApplicationOpen]);

    useEffect(() => {
        const script = document.createElement('script');
        script.src = '//platform-api.sharethis.com/js/sharethis.js#property=64807f9aab7e090012d1dbb0&amp;product=inline-share-buttons&amp;source=platform';
        script.async = true;
        document.body.appendChild(script);

        return () => {
            // clearTimeout(timeout);
        };
    }, []);

    if (showLocationModal && isMobile) {
        return <LocationModalMobile setShowLocationModal={setShowLocationModal} jobLocations={jobLocations} />
    }

    if (showLocationSelectionModal && isTablet) {
        return <JobLocationSelectionModalMobile jobLocations={jobLocations} setShowLocationSelectionModal={setShowLocationSelectionModal} handleSelectionModalNextButton={handleSelectionModalNextButton} selectedMallIds={selectedMallIds} handleCheckboxClick={handleCheckboxClick} locationLimit={locationLimit} />
    }

    if (isSuccess) {
        return <JobApplySuccess latestJobs={latestJobs} applicationMethod={applicationMethod} company={data.coydispm} jobPosition={data.jobttl} />
    }
    const IsUserLoggedIn = () => {
        return localStorage.getItem('isLogin') !== null;
    }

    return (
        <div className='fab-main-container'>
            {(isLoading || areAppliedJobsLoading) && <Loader></Loader>}
            {showToast && <Toast type={toastProps.type} header={toastProps.header} message={toastProps.message} onClose={handleToastClose} />}
            <Header />
            <div className='job-ad-detail-container'>
                <div className='fab-container fab-job-ad-detail'>
                    <div className='fab-job-ad-detail-wrapper'>
                        <div className='fab-job-ad-info'>
                            <div className='job-detail-header-container'>
                                <h4 className='fab-job-ad-title'>{data.jobttl}</h4>
                                <svg style={{ visibility: IsUserLoggedIn() ? '' : 'hidden' }} className={`fab-job-ad-detail-save ${isBookmark ? 'fab-latestjob-bookmark-active' : ''}`}
                                    onClick={() => handleBookmarkClick()}
                                    width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fillRule="evenodd" clipRule="evenodd" d="M6.32046 2.57741C8.18398 2.36114 10.0793 2.25 12.0002 2.25C13.9212 2.25 15.8165 2.36114 17.68 2.57741C19.1774 2.75119 20.2502 4.03722 20.2502 5.50699V21C20.2502 21.2599 20.1157 21.5013 19.8945 21.638C19.6734 21.7746 19.3973 21.7871 19.1648 21.6708L12.0002 18.0885L4.83565 21.6708C4.60316 21.7871 4.32706 21.7746 4.10595 21.638C3.88483 21.5013 3.75024 21.2599 3.75024 21V5.50699C3.75024 4.03722 4.82308 2.75119 6.32046 2.57741Z" fill="#FFFFFF" />
                                </svg>
                            </div>
                            {!isEmpty(data.salmin) && <span className='fab-job-ad-salary'>
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fillRule="evenodd" clipRule="evenodd" d="M1.25 4.6875C1.25 3.82456 1.94956 3.125 2.8125 3.125H17.1875C18.0504 3.125 18.75 3.82456 18.75 4.6875V12.8125C18.75 13.6754 18.0504 14.375 17.1875 14.375H2.8125C1.94955 14.375 1.25 13.6754 1.25 12.8125V4.6875ZM16.25 13.125H3.75C3.75 12.4346 3.19036 11.875 2.5 11.875V5.625C3.19036 5.625 3.75 5.06536 3.75 4.375H16.25C16.25 5.06536 16.8096 5.625 17.5 5.625V11.875C16.8096 11.875 16.25 12.4346 16.25 13.125ZM10 6.875C8.96447 6.875 8.125 7.71447 8.125 8.75C8.125 9.78553 8.96447 10.625 10 10.625C11.0355 10.625 11.875 9.78553 11.875 8.75C11.875 7.71447 11.0355 6.875 10 6.875ZM6.875 8.75C6.875 7.02411 8.27411 5.625 10 5.625C11.7259 5.625 13.125 7.02411 13.125 8.75C13.125 10.4759 11.7259 11.875 10 11.875C8.27411 11.875 6.875 10.4759 6.875 8.75ZM4.375 8.75C4.375 8.40482 4.65482 8.125 5 8.125H5.00625C5.35143 8.125 5.63125 8.40482 5.63125 8.75V8.75625C5.63125 9.10143 5.35143 9.38125 5.00625 9.38125H5C4.65482 9.38125 4.375 9.10143 4.375 8.75625V8.75ZM14.375 8.75C14.375 8.40482 14.6548 8.125 15 8.125H15.0062C15.3514 8.125 15.6312 8.40482 15.6312 8.75V8.75625C15.6312 9.10143 15.3514 9.38125 15.0062 9.38125H15C14.6548 9.38125 14.375 9.10143 14.375 8.75625V8.75ZM1.25 15.625C1.25 15.2798 1.52982 15 1.875 15C6.48695 15 10.9558 15.6169 15.2031 16.773C15.4226 16.8327 15.625 16.667 15.625 16.4626V15.625C15.625 15.2798 15.9048 15 16.25 15C16.5952 15 16.875 15.2798 16.875 15.625V16.4626C16.875 17.514 15.867 18.2491 14.8748 17.9791C10.7335 16.8518 6.37504 16.25 1.875 16.25C1.52982 16.25 1.25 15.9702 1.25 15.625Z" fill="#D31145" />
                                </svg>
                                {data.salindi} {` $${data.salmin}`} {data.salperiod}
                            </span>}
                            <span className='fab-job-ad-location'>
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fillRule="evenodd" clipRule="evenodd" d="M10 3.125C6.8934 3.125 4.375 5.6434 4.375 8.75C4.375 11.4966 5.81723 13.6919 7.32212 15.2327C8.07062 15.9991 8.82091 16.5888 9.38405 16.9867C9.63237 17.1621 9.84321 17.2994 10 17.3974C10.1568 17.2994 10.3676 17.1621 10.6159 16.9867C11.1791 16.5888 11.9294 15.9991 12.6779 15.2327C14.1828 13.6919 15.625 11.4966 15.625 8.75C15.625 5.6434 13.1066 3.125 10 3.125ZM10 18.125C9.69976 18.6732 9.69954 18.673 9.6993 18.6729L9.69705 18.6717L9.69206 18.6689L9.67542 18.6596C9.66141 18.6517 9.64163 18.6405 9.61646 18.6259C9.56612 18.5967 9.49419 18.5542 9.40375 18.4985C9.22295 18.3872 8.96771 18.223 8.66282 18.0076C8.05409 17.5776 7.24188 16.9395 6.42788 16.1061C4.80777 14.4474 3.125 11.9551 3.125 8.75C3.125 4.95304 6.20304 1.875 10 1.875C13.797 1.875 16.875 4.95304 16.875 8.75C16.875 11.9551 15.1922 14.4474 13.5721 16.1061C12.7581 16.9395 11.9459 17.5776 11.3372 18.0076C11.0323 18.223 10.7771 18.3872 10.5963 18.4985C10.5058 18.5542 10.4339 18.5967 10.3835 18.6259C10.3584 18.6405 10.3386 18.6517 10.3246 18.6596L10.3079 18.6689L10.303 18.6717L10.3013 18.6726C10.3011 18.6727 10.3002 18.6732 10 18.125ZM10 18.125L10.3002 18.6732C10.1132 18.7756 9.88635 18.7754 9.6993 18.6729L10 18.125ZM10 6.875C8.96447 6.875 8.125 7.71447 8.125 8.75C8.125 9.78553 8.96447 10.625 10 10.625C11.0355 10.625 11.875 9.78553 11.875 8.75C11.875 7.71447 11.0355 6.875 10 6.875ZM6.875 8.75C6.875 7.02411 8.27411 5.625 10 5.625C11.7259 5.625 13.125 7.02411 13.125 8.75C13.125 10.4759 11.7259 11.875 10 11.875C8.27411 11.875 6.875 10.4759 6.875 8.75Z" fill="#3F3F46" />
                                </svg>
                                {data.loc ? data.loc : "Singapore"}
                                {(jobLocations.length > 0
                                ) && <button className="fab-job-ad-see-all-button" onClick={handleSeeAll}>
                                        (see all)
                                    </button>}
                            </span>
                            {data.timing && <span className='fab-job-ad-schedule'>
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M10.625 10.625C10.625 10.9702 10.3452 11.25 10 11.25C9.65482 11.25 9.375 10.9702 9.375 10.625C9.375 10.2798 9.65482 10 10 10C10.3452 10 10.625 10.2798 10.625 10.625Z" fill="#3F3F46" />
                                    <path d="M6.25 13.125C6.59518 13.125 6.875 12.8452 6.875 12.5C6.875 12.1548 6.59518 11.875 6.25 11.875C5.90482 11.875 5.625 12.1548 5.625 12.5C5.625 12.8452 5.90482 13.125 6.25 13.125Z" fill="#3F3F46" />
                                    <path d="M6.875 14.375C6.875 14.7202 6.59518 15 6.25 15C5.90482 15 5.625 14.7202 5.625 14.375C5.625 14.0298 5.90482 13.75 6.25 13.75C6.59518 13.75 6.875 14.0298 6.875 14.375Z" fill="#3F3F46" />
                                    <path d="M8.125 13.125C8.47018 13.125 8.75 12.8452 8.75 12.5C8.75 12.1548 8.47018 11.875 8.125 11.875C7.77982 11.875 7.5 12.1548 7.5 12.5C7.5 12.8452 7.77982 13.125 8.125 13.125Z" fill="#3F3F46" />
                                    <path d="M8.75 14.375C8.75 14.7202 8.47018 15 8.125 15C7.77982 15 7.5 14.7202 7.5 14.375C7.5 14.0298 7.77982 13.75 8.125 13.75C8.47018 13.75 8.75 14.0298 8.75 14.375Z" fill="#3F3F46" />
                                    <path d="M10 13.125C10.3452 13.125 10.625 12.8452 10.625 12.5C10.625 12.1548 10.3452 11.875 10 11.875C9.65482 11.875 9.375 12.1548 9.375 12.5C9.375 12.8452 9.65482 13.125 10 13.125Z" fill="#3F3F46" />
                                    <path d="M10.625 14.375C10.625 14.7202 10.3452 15 10 15C9.65482 15 9.375 14.7202 9.375 14.375C9.375 14.0298 9.65482 13.75 10 13.75C10.3452 13.75 10.625 14.0298 10.625 14.375Z" fill="#3F3F46" />
                                    <path d="M11.875 13.125C12.2202 13.125 12.5 12.8452 12.5 12.5C12.5 12.1548 12.2202 11.875 11.875 11.875C11.5298 11.875 11.25 12.1548 11.25 12.5C11.25 12.8452 11.5298 13.125 11.875 13.125Z" fill="#3F3F46" />
                                    <path d="M12.5 14.375C12.5 14.7202 12.2202 15 11.875 15C11.5298 15 11.25 14.7202 11.25 14.375C11.25 14.0298 11.5298 13.75 11.875 13.75C12.2202 13.75 12.5 14.0298 12.5 14.375Z" fill="#3F3F46" />
                                    <path d="M13.75 13.125C14.0952 13.125 14.375 12.8452 14.375 12.5C14.375 12.1548 14.0952 11.875 13.75 11.875C13.4048 11.875 13.125 12.1548 13.125 12.5C13.125 12.8452 13.4048 13.125 13.75 13.125Z" fill="#3F3F46" />
                                    <path d="M12.5 10.625C12.5 10.9702 12.2202 11.25 11.875 11.25C11.5298 11.25 11.25 10.9702 11.25 10.625C11.25 10.2798 11.5298 10 11.875 10C12.2202 10 12.5 10.2798 12.5 10.625Z" fill="#3F3F46" />
                                    <path d="M13.75 11.25C14.0952 11.25 14.375 10.9702 14.375 10.625C14.375 10.2798 14.0952 10 13.75 10C13.4048 10 13.125 10.2798 13.125 10.625C13.125 10.9702 13.4048 11.25 13.75 11.25Z" fill="#3F3F46" />
                                    <path fillRule="evenodd" clipRule="evenodd" d="M5.625 1.875C5.97018 1.875 6.25 2.15482 6.25 2.5V3.75H13.75V2.5C13.75 2.15482 14.0298 1.875 14.375 1.875C14.7202 1.875 15 2.15482 15 2.5V3.75H15.625C17.0057 3.75 18.125 4.86929 18.125 6.25V15.625C18.125 17.0057 17.0057 18.125 15.625 18.125H4.375C2.99429 18.125 1.875 17.0057 1.875 15.625V6.25C1.875 4.86929 2.99429 3.75 4.375 3.75H5V2.5C5 2.15482 5.27982 1.875 5.625 1.875ZM16.875 9.375C16.875 8.68464 16.3154 8.125 15.625 8.125H4.375C3.68464 8.125 3.125 8.68464 3.125 9.375V15.625C3.125 16.3154 3.68464 16.875 4.375 16.875H15.625C16.3154 16.875 16.875 16.3154 16.875 15.625V9.375Z" fill="#3F3F46" />
                                </svg>
                                {data.timing}
                            </span>}
                            <div className='fab-jobs-ad-tags'>
                                {
                                    data.jobtypes && data.jobtypes.map((jobType) => <span className='fab-jobs-ad-pill'>{jobType}</span>)
                                }
                            </div>
                            <div className='fab-job-ad-dates'>
                                <span className='fab-job-ad-date'>Date updated: {data.pubdttme}</span>
                                <span className='fab-job-ad-expiry'>Expiry date: {data.expdttme}</span>
                            </div>
                        </div>
                        <div >
                            <div className='fab-job-ad-descriptions-wrapper' dangerouslySetInnerHTML={{ __html: sanitizeHtml(data.desc) }} />
                        </div>
                    </div>
                    <div className='fab-job-ad-detail-side'>
                        <div className='fab-job-ad-detail-employer'>
                            {
                                data.logo ? <img className='fab-job-ad-image' src={data.logo} alt="" /> :
                                    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                                        <path d="M0 4C0 1.79086 1.79086 0 4 0H36C38.2091 0 40 1.79086 40 4V36C40 38.2091 38.2091 40 36 40H4C1.79086 40 0 38.2091 0 36V4Z" fill="url(#pattern0_3854_7362)" />
                                        <defs>
                                            <pattern id="pattern0_3854_7362" patternContentUnits="objectBoundingBox" width="1" height="1">
                                                <use xlinkHref="#image0_3854_7362" transform="scale(0.0078125)" />
                                            </pattern>
                                            <image id="image0_3854_7362" width="128" height="128" xlinkHref="data:image/png;base64,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" />
                                        </defs>
                                    </svg>
                            }
                            <div className='fab-job-ad-company-brn'>
                                <h5 className='fab-job-ad-company'>{data.coydispm}</h5>
                                <span className='fab-job-ad-brn'>BRN/UEN: {data.uen}</span>
                            </div>
                        </div>
                        <span className='fab-job-ad-job-ttl'>
                            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="24" viewBox="0 0 40 24" fill="none">
                                <path fillRule="evenodd" clipRule="evenodd" d="M16.25 6.375C16.25 4.99429 17.3693 3.875 18.75 3.875H21.25C22.6307 3.875 23.75 4.99429 23.75 6.375V6.54581C24.5271 6.61695 25.2978 6.70997 26.0617 6.82426C27.2734 7.00557 28.125 8.05969 28.125 9.25474V12.4074C28.125 13.0211 27.9007 13.6096 27.5 14.0537V17.3333C27.5 18.5432 26.6273 19.6062 25.3974 19.7695C23.6313 20.004 21.8296 20.125 20 20.125C18.1704 20.125 16.3687 20.004 14.6026 19.7695C13.3727 19.6062 12.5 18.5432 12.5 17.3333V14.0537C12.0993 13.6096 11.875 13.0211 11.875 12.4074V9.25474C11.875 8.05969 12.7266 7.00557 13.9383 6.82426C14.7022 6.70997 15.4729 6.61695 16.25 6.54581V6.375ZM17.5 6.45069C18.327 6.40047 19.1605 6.375 20 6.375C20.8395 6.375 21.673 6.40047 22.5 6.45069V6.375C22.5 5.68464 21.9404 5.125 21.25 5.125H18.75C18.0596 5.125 17.5 5.68464 17.5 6.375V6.45069ZM13.75 14.7859V17.3333C13.75 17.9475 14.1888 18.4536 14.7671 18.5304C16.4788 18.7577 18.2256 18.875 20 18.875C21.7744 18.875 23.5212 18.7577 25.2329 18.5304C25.8112 18.4536 26.25 17.9475 26.25 17.3333V14.7859C24.2778 15.4123 22.1778 15.75 20 15.75C17.8222 15.75 15.7222 15.4123 13.75 14.7859ZM20 7.625C18.9644 7.625 17.9384 7.66496 16.9232 7.74341C15.9801 7.81629 15.0464 7.92238 14.1233 8.0605C13.5532 8.14579 13.125 8.64822 13.125 9.25474V12.4074C13.125 12.7726 13.2814 13.1037 13.5305 13.316C13.6321 13.4026 13.7502 13.4706 13.8829 13.5147C15.805 14.1537 17.8614 14.5 20 14.5C22.1386 14.5 24.195 14.1538 26.1171 13.5147C26.2498 13.4706 26.3679 13.4026 26.4695 13.316C26.7186 13.1037 26.875 12.7726 26.875 12.4074V9.25474C26.875 8.64822 26.4468 8.14579 25.8767 8.0605C24.9536 7.92238 24.0199 7.81629 23.0768 7.74341C22.0617 7.66496 21.0356 7.625 20 7.625ZM19.375 12.625C19.375 12.2798 19.6548 12 20 12H20.0062C20.3514 12 20.6312 12.2798 20.6312 12.625V12.6312C20.6312 12.9764 20.3514 13.2562 20.0062 13.2562H20C19.6548 13.2562 19.375 12.9764 19.375 12.6312V12.625Z" fill="#3F3F46" />
                            </svg>
                            {data.jobttl}
                        </span>
                        {!isEmpty(data.salmin) && <span className='fab-job-ad-salary'>
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fillRule="evenodd" clipRule="evenodd" d="M1.25 4.6875C1.25 3.82456 1.94956 3.125 2.8125 3.125H17.1875C18.0504 3.125 18.75 3.82456 18.75 4.6875V12.8125C18.75 13.6754 18.0504 14.375 17.1875 14.375H2.8125C1.94955 14.375 1.25 13.6754 1.25 12.8125V4.6875ZM16.25 13.125H3.75C3.75 12.4346 3.19036 11.875 2.5 11.875V5.625C3.19036 5.625 3.75 5.06536 3.75 4.375H16.25C16.25 5.06536 16.8096 5.625 17.5 5.625V11.875C16.8096 11.875 16.25 12.4346 16.25 13.125ZM10 6.875C8.96447 6.875 8.125 7.71447 8.125 8.75C8.125 9.78553 8.96447 10.625 10 10.625C11.0355 10.625 11.875 9.78553 11.875 8.75C11.875 7.71447 11.0355 6.875 10 6.875ZM6.875 8.75C6.875 7.02411 8.27411 5.625 10 5.625C11.7259 5.625 13.125 7.02411 13.125 8.75C13.125 10.4759 11.7259 11.875 10 11.875C8.27411 11.875 6.875 10.4759 6.875 8.75ZM4.375 8.75C4.375 8.40482 4.65482 8.125 5 8.125H5.00625C5.35143 8.125 5.63125 8.40482 5.63125 8.75V8.75625C5.63125 9.10143 5.35143 9.38125 5.00625 9.38125H5C4.65482 9.38125 4.375 9.10143 4.375 8.75625V8.75ZM14.375 8.75C14.375 8.40482 14.6548 8.125 15 8.125H15.0062C15.3514 8.125 15.6312 8.40482 15.6312 8.75V8.75625C15.6312 9.10143 15.3514 9.38125 15.0062 9.38125H15C14.6548 9.38125 14.375 9.10143 14.375 8.75625V8.75ZM1.25 15.625C1.25 15.2798 1.52982 15 1.875 15C6.48695 15 10.9558 15.6169 15.2031 16.773C15.4226 16.8327 15.625 16.667 15.625 16.4626V15.625C15.625 15.2798 15.9048 15 16.25 15C16.5952 15 16.875 15.2798 16.875 15.625V16.4626C16.875 17.514 15.867 18.2491 14.8748 17.9791C10.7335 16.8518 6.37504 16.25 1.875 16.25C1.52982 16.25 1.25 15.9702 1.25 15.625Z" fill="#D31145" />
                            </svg>
                            {data.salindi} {` $${data.salmin}`} {data.salperiod}
                        </span>}
                        <span className='fab-job-ad-location'>
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fillRule="evenodd" clipRule="evenodd" d="M10 3.125C6.8934 3.125 4.375 5.6434 4.375 8.75C4.375 11.4966 5.81723 13.6919 7.32212 15.2327C8.07062 15.9991 8.82091 16.5888 9.38405 16.9867C9.63237 17.1621 9.84321 17.2994 10 17.3974C10.1568 17.2994 10.3676 17.1621 10.6159 16.9867C11.1791 16.5888 11.9294 15.9991 12.6779 15.2327C14.1828 13.6919 15.625 11.4966 15.625 8.75C15.625 5.6434 13.1066 3.125 10 3.125ZM10 18.125C9.69976 18.6732 9.69954 18.673 9.6993 18.6729L9.69705 18.6717L9.69206 18.6689L9.67542 18.6596C9.66141 18.6517 9.64163 18.6405 9.61646 18.6259C9.56612 18.5967 9.49419 18.5542 9.40375 18.4985C9.22295 18.3872 8.96771 18.223 8.66282 18.0076C8.05409 17.5776 7.24188 16.9395 6.42788 16.1061C4.80777 14.4474 3.125 11.9551 3.125 8.75C3.125 4.95304 6.20304 1.875 10 1.875C13.797 1.875 16.875 4.95304 16.875 8.75C16.875 11.9551 15.1922 14.4474 13.5721 16.1061C12.7581 16.9395 11.9459 17.5776 11.3372 18.0076C11.0323 18.223 10.7771 18.3872 10.5963 18.4985C10.5058 18.5542 10.4339 18.5967 10.3835 18.6259C10.3584 18.6405 10.3386 18.6517 10.3246 18.6596L10.3079 18.6689L10.303 18.6717L10.3013 18.6726C10.3011 18.6727 10.3002 18.6732 10 18.125ZM10 18.125L10.3002 18.6732C10.1132 18.7756 9.88635 18.7754 9.6993 18.6729L10 18.125ZM10 6.875C8.96447 6.875 8.125 7.71447 8.125 8.75C8.125 9.78553 8.96447 10.625 10 10.625C11.0355 10.625 11.875 9.78553 11.875 8.75C11.875 7.71447 11.0355 6.875 10 6.875ZM6.875 8.75C6.875 7.02411 8.27411 5.625 10 5.625C11.7259 5.625 13.125 7.02411 13.125 8.75C13.125 10.4759 11.7259 11.875 10 11.875C8.27411 11.875 6.875 10.4759 6.875 8.75Z" fill="#3F3F46" />
                            </svg>
                            {data.loc ? data.loc : "Singapore"}
                        </span>
                        <div className='fab-jobs-ad-tags'>
                            {
                                data.jobtypes && data.jobtypes.map((jobType) => <span className='fab-jobs-ad-pill'>{jobType}</span>)
                            }
                        </div>
                        <div className='fab-job-ad-detail-buttons'>
                            <Button variant="outline" size="lg" className='fab-job-btn-view-employer' onClick={handleEmployer}>View employer profile</Button>
                            {
                                appliedJobIds.includes(jobId) ?
                                    <Button variant='primary' size='lg' className='fab-job-btn-apply' isDisabled={true}>Already applied for this job</Button>
                                    :
                                    <Button variant="primary" size="lg" className='fab-job-btn-apply' onClick={handleApplyButtonClick}>Apply for this job</Button>
                            }
                        </div>
                        <div>
                            <div className='fab-job-ad-location'>Share this job to your friends</div>
                            <ShareJobButtons title={data.jobttl}></ShareJobButtons>
                        </div>
                    </div>
                </div>
                <div className='fab-apply-btn-mobile-container'>
                    <svg style={{ visibility: IsUserLoggedIn() ? '' : 'hidden' }} className={`fab-job-ad-detail-save-mobile ${isBookmark ? 'fab-latestjob-bookmark-active' : ''}`}
                        onClick={() => handleBookmarkClick()}
                        width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fillRule="evenodd" clipRule="evenodd" d="M6.32046 2.57741C8.18398 2.36114 10.0793 2.25 12.0002 2.25C13.9212 2.25 15.8165 2.36114 17.68 2.57741C19.1774 2.75119 20.2502 4.03722 20.2502 5.50699V21C20.2502 21.2599 20.1157 21.5013 19.8945 21.638C19.6734 21.7746 19.3973 21.7871 19.1648 21.6708L12.0002 18.0885L4.83565 21.6708C4.60316 21.7871 4.32706 21.7746 4.10595 21.638C3.88483 21.5013 3.75024 21.2599 3.75024 21V5.50699C3.75024 4.03722 4.82308 2.75119 6.32046 2.57741Z" fill="#FFFFFF" />
                    </svg>
                    {
                        appliedJobIds.includes(jobId) ?
                            <Button variant='primary' size='lg' className='fab-job-btn-apply-m' isDisabled={true}>Already applied for this job</Button>
                            :
                            <Button variant="primary" size="lg" className='fab-job-btn-apply-m' onClick={handleApplyButtonClick}>Apply for this job</Button>
                    }
                </div>
            </div>
            {/* Latest jobs */}
            <div className='fab-container fab-latest-jobs'>
                <div>
                    <div className='fab-homepage-title-wrapper'>
                        <h3 className='fab-latest-jobs-title'>A few more jobs you might be interested in</h3>
                    </div>
                    <LatestJobs latestJobData={latestJobs} location='Company listing' />
                    <div className='fab-latest-job-button' style={{ display: 'flex' }}>
                        <Button variant="outline" size="md" onClick={handleMoreJobs}>See more jobs like this</Button>
                    </div>
                </div>
            </div>
            <Footer />
            {isApplicationOpen && <ProgressiveApplication isOpen={isApplicationOpen} handleApply={handleApply} isMobileVerified={isMobileVerified} mobileNumber={mobileNumber} isLanguageFilled={isLanguageFilled} isEmploymentstatusFilled={isEmploymentstatusFilled} isEducationFilled={isEducationFilled} setIsMobileVerified={setIsMobileVerified} setIsApplicationOpen={setIsApplicationOpen} />}
            {showLocationModal ? <LocationModal jobLocations={jobLocations} handleModalClose={handleLocationModalClose} showLocationModal={showLocationModal} /> : <></>}
            {showLocationSelectionModal ? <JobLocationSelectionModal jobLocations={jobLocations} handleClose={handleSelectionModalClose} showLocationSelectionModal={showLocationSelectionModal} handleSelectionModalNextButton={handleSelectionModalNextButton} selectedMallIds={selectedMallIds} handleCheckboxClick={handleCheckboxClick} locationLimit={locationLimit} /> : <></>}
            {showApplicationMethodModal ? <ApplicationMethodModal setShowApplicationMethodModal={setShowApplicationMethodModal} showApplicationMethodModal={showApplicationMethodModal} handleJobApply={handleJobApply} setApplicationMethod={setApplicationMethod} whatsAppNo={data?.whatsapp} outlets={selectedMallIds} /> : <></>}
        </div>
    );
}

export default JobAdDetails;
